import {IconSize, iconStrokeWidthBySize} from '../icon_types';

type CopyIconProps = {
  id?: string;
  className?: string;
  size: IconSize;
  color?: string;
};

const pathDsBySize = {
  '16': [
    'M13.3333 6H7.33333C6.59695 6 6 6.59695 6 7.33333V13.3333C6 14.0697 6.59695 14.6667 7.33333 14.6667H13.3333C14.0697 14.6667 14.6667 14.0697 14.6667 13.3333V7.33333C14.6667 6.59695 14.0697 6 13.3333 6Z',
    'M3.33301 10H2.66634C2.31272 10 1.97358 9.85956 1.72353 9.60952C1.47348 9.35947 1.33301 9.02033 1.33301 8.66671V2.66671C1.33301 2.31309 1.47348 1.97395 1.72353 1.7239C1.97358 1.47385 2.31272 1.33337 2.66634 1.33337H8.66634C9.01996 1.33337 9.3591 1.47385 9.60915 1.7239C9.8592 1.97395 9.99967 2.31309 9.99967 2.66671V3.33337',
  ],
  '24': [
    'M20 9H11C9.89543 9 9 9.89543 9 11V20C9 21.1046 9.89543 22 11 22H20C21.1046 22 22 21.1046 22 20V11C22 9.89543 21.1046 9 20 9Z',
    'M5 15H4C3.46957 15 2.96086 14.7893 2.58579 14.4142C2.21071 14.0391 2 13.5304 2 13V4C2 3.46957 2.21071 2.96086 2.58579 2.58579C2.96086 2.21071 3.46957 2 4 2H13C13.5304 2 14.0391 2.21071 14.4142 2.58579C14.7893 2.96086 15 3.46957 15 4V5',
  ],
  '32': [
    'M26.6667 12H14.6667C13.1939 12 12 13.1939 12 14.6667V26.6667C12 28.1394 13.1939 29.3333 14.6667 29.3333H26.6667C28.1394 29.3333 29.3333 28.1394 29.3333 26.6667V14.6667C29.3333 13.1939 28.1394 12 26.6667 12Z',
    'M6.6665 20H5.33317C4.62593 20 3.94765 19.7191 3.44755 19.219C2.94746 18.7189 2.6665 18.0406 2.6665 17.3334V5.33335C2.6665 4.62611 2.94746 3.94783 3.44755 3.44774C3.94765 2.94764 4.62593 2.66669 5.33317 2.66669H17.3332C18.0404 2.66669 18.7187 2.94764 19.2188 3.44774C19.7189 3.94783 19.9998 4.62611 19.9998 5.33335V6.66669',
  ],
};

const CopyIcon = (props: CopyIconProps) => {
  const {id, className, size, color} = props;
  const paths = pathDsBySize[size];
  const colorOptions = color || 'currentColor' || '#1E1E20';

  return (
    <svg
      id={id}
      className={className}
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none">
      {paths.map((d, index) => (
        <path
          key={index}
          d={d}
          stroke={colorOptions}
          strokeWidth={iconStrokeWidthBySize[size]}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ))}
    </svg>
  );
};

export default CopyIcon;
